import { Link } from 'react-router-dom';
import { lists } from '../resource/NavList';

import madelogo from '../assets/images/MWC_White_CampaignStamp_English-150x150.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';

function Footer() {
  const NavList = ({ list }) => (
    <li>
      <Link to={list.direction}>{list.name}</Link>
    </li>
  );

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__wrapper column">
          <div className="footer__row row">
            <div className="footer__content column">
              <div className="footer__title">
                <h1>Contact</h1>
              </div>
              <div className="footer__shoppingmall">
                <ul>
                  <li>📞 070 5117 2759</li>
                  <li>📱 +64 21 898 325 </li>
                  <li>📧 admin@purelifespanworld-korea.com</li>
                  <li>🏠 4 Currys Lane, Wairau Valley, Auckland, 0627, NZ</li>
                </ul>
              </div>
            </div>
            <div className="footer__content column">
              <div className="footer__content-nav column">
                <ol className="footer__nav-list">
                  {lists.map((list) => (
                    <NavList key={list.id} list={list} />
                  ))}
                </ol>
              </div>
            </div>
            <div className="footer__content column">
              <div className="footer__content-logo">
                <Link to="/commitment">
                  <img src={madelogo} alt="Made with care New Zealand" />
                </Link>
              </div>
            </div>
            <div className="footer__content column">
              <div className="footer__title">
                <h1>소셜미디어</h1>
              </div>
              <div className="footer__sns">
                <ol className="footer__sns-list">
                  <li>
                    <div className="footer__sns-item">
                      <a
                        href="https://www.facebook.com/purelifespan/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FontAwesomeIcon
                          className="sns__item-icon"
                          icon={faFacebookF}
                        />
                        <span> 페이스북 </span>
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="footer__sns-item">
                      <a
                        href="https://www.linkedin.com/company/lifespan-new-zealand"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FontAwesomeIcon
                          className="sns__item-icon"
                          icon={faLinkedinIn}
                        />
                        <span>링크드인 </span>
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="footer__sns-item">
                      <a
                        href="https://www.instagram.com/pure_lifespan/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <FontAwesomeIcon
                          className="sns__item-icon"
                          icon={faInstagram}
                        />
                        <span>인스타그램 </span>
                      </a>
                    </div>
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div className="footer__copyright">
            <p>
              © 2020-2021 Lifespan NZ & ABI Trading Ltd. All rights reserved.
            </p>
            <p> Website design: KOPARA</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
